import React from "react";
import {
  Navigate,
  Route,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { MyContext } from "../context/AuthUseContext";
import { Box, useToast } from "@chakra-ui/react";
import { Home } from "../Pages/Home";

const PrivateRoute = ({ children }) => {
  function showAlert() {
    return toast({
      position: "bottom-left",
      title: "Not Signed In",
      description: "Please Sign In First",
      status: "warning",
      duration: 9000,
      isClosable: true,
    });
  }
  const toast = useToast();
  const { user, loginWithRedirect, isAuthenticated, logout } =
    React.useContext(MyContext);

  const params = useLocation().state?.currentUrl;
  // const navigate = useNavigate();
  console.log(params, "params", useLocation().state);
  console.log(isAuthenticated, "isAuthenticated");
  if (!isAuthenticated) {
    showAlert();

    //  navigate('/');
    return <Navigate to={params ? params : "/"} />;
    return;
  }
  return <Box>{children}</Box>;
};
export default PrivateRoute;
